import type {
    CalibrationAdjustment,
    CalibrationAdjustmentUpdateRequest,
    CalibrationBulkAdjustmentRequest,
    CalibrationBulkAdjustmentResponse,
    CalibrationCycle,
    CalibrationPublishResponse,
    CalibrationReport,
    CalibrationReportFilters,
} from '@/types/calibration';

import { api } from '@/api/api';

export interface SaveCalibrationAdjustmentParams {
    cycleEvaluationId: string;
    employeeId: string;
    request: CalibrationAdjustmentUpdateRequest;
}

export default {
    async getCycles(): Promise<CalibrationCycle[]> {
        const response = await api.get('/Calibration/Cycles');
        return response.data;
    },

    async getReport(
        cycleEvaluationId: string,
        filters?: CalibrationReportFilters,
    ): Promise<CalibrationReport> {
        const response = await api.get('/Calibration/Report', {
            params: { cycleEvaluationId, ...filters },
        });
        return response.data;
    },

    async saveAdjustment({
        cycleEvaluationId,
        employeeId,
        request,
    }: SaveCalibrationAdjustmentParams): Promise<CalibrationAdjustment> {
        const response = await api.put(
            `/Calibration/Adjustments/${cycleEvaluationId}/${employeeId}`,
            request,
        );
        return response.data;
    },

    async bulkAdjust(
        cycleEvaluationId: string,
        request: CalibrationBulkAdjustmentRequest,
    ): Promise<CalibrationBulkAdjustmentResponse> {
        const response = await api.post(
            `/Calibration/Adjustments/${cycleEvaluationId}/Bulk`,
            request,
        );
        return response.data;
    },

    async publishAdjustments(cycleEvaluationId: string): Promise<CalibrationPublishResponse> {
        const response = await api.post(`/Calibration/Adjustments/${cycleEvaluationId}/Publish`);
        return response.data;
    },
};
